<fieldset class="app-col">
  <legend>Preset Settings</legend>
  <div class="form-group">
    <label class="control-label">Preset Name:</label>
    <input (ngModelChange)="NotifyListeners()" #attrName_input [(ngModel)]="name" type="text" class='form-control' />
  </div>
  <div class="form-group">
    <label class="control-label">Preset Data</label>
    <app-data-entry (changes)="NotifyListeners()" [project]="project" [featureType]="presetFeatureType" [data]="presetData"></app-data-entry>
  </div>
 </fieldset>
